import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { period: String }

  connect() {
    // Stimulus controller for super admin dashboard date navigation
  }

  previousPeriod(event) {
    event.preventDefault()
    this.navigatePeriod(-1)
  }

  nextPeriod(event) {
    event.preventDefault()
    this.navigatePeriod(1)
  }

  goToToday(event) {
    event.preventDefault()
    const urlParams = new URLSearchParams(window.location.search)
    const period = urlParams.get('period') || 'monthly'
    const tab = urlParams.get('tab') || 'turnero'
    const doctorId = urlParams.get('doctor_id')
    // Use UTC to avoid timezone issues - Rails will handle timezone conversion
    const today = this.getUTCDateString(new Date())

    const newUrl = new URL(window.location)
    newUrl.searchParams.set('date', today)
    newUrl.searchParams.set('period', period)
    newUrl.searchParams.set('tab', tab)
    if (doctorId) {
      newUrl.searchParams.set('doctor_id', doctorId)
    }

    window.location.href = newUrl.toString()
  }

  navigatePeriod(direction) {
    const urlParams = new URLSearchParams(window.location.search)
    const period = urlParams.get('period') || this.periodValue || 'monthly'
    const currentDate = new Date(urlParams.get('date') || new Date())
    const tab = urlParams.get('tab') || 'turnero'
    const doctorId = urlParams.get('doctor_id')

    let newDate = new Date(currentDate)

    switch(period) {
      case 'daily':
        newDate.setDate(currentDate.getDate() + direction)
        break
      case 'weekly':
        newDate.setDate(currentDate.getDate() + (7 * direction))
        break
      case 'monthly':
        newDate.setMonth(currentDate.getMonth() + direction)
        break
    }

    const newUrl = new URL(window.location)
    newUrl.searchParams.set('date', this.getUTCDateString(newDate))
    newUrl.searchParams.set('period', period)
    newUrl.searchParams.set('tab', tab)
    if (doctorId) {
      newUrl.searchParams.set('doctor_id', doctorId)
    }

    window.location.href = newUrl.toString()
  }

  // Helper to get UTC date string in YYYY-MM-DD format
  // This avoids timezone conversion issues when passing dates to Rails
  getUTCDateString(date) {
    const year = date.getFullYear()
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }
}
